(function () {
    'use strict';

    run.admin.parts.rackootButtonShare = function () {
        const csrf_name = document.getElementsByName('csrf_name')[0].value;
        const csrf_value = document.getElementsByName('csrf_value')[0].value;

        const rackoot_data = document.querySelector('.rackoot__data');
        if (rackoot_data == null) {
            return;
        }

        const rackoots_items__share = document.getElementById('rackoots_items__share');
        if (rackoots_items__share) {
            rackoots_items__share.addEventListener('click', function (e) {
                rackootShare(rackoot_data);
            });
        }

        async function rackootShare(rackoot) {
            const rackoot_name = rackoot.dataset.name;
            const checked = (rackoot.dataset.public == 'true') ? 'checked="checked"' : '';
            const suggestionsChecked = (rackoot.dataset.acceptSuggestions == 'true') ? 'checked="checked"' : '';
            
            let share_buttons_template = document.getElementById('rackoot_share_buttons').innerHTML;
            share_buttons_template = replaceAll(share_buttons_template, {
                '{share_text}': encodeURIComponent(translations.rackoots.share.shareText.replace('{rackoot_name}', rackoot_name)),
                '{share_url}': encodeURIComponent(rackoot_data.dataset.publicUrl),
            });

            const is_logged = document.body.classList.contains('user_logged_in');
            const view_type = document.getElementById('rackoot_data').dataset.viewType;

            let display_class = '';
            let html = `<div id="rackoot_share_dialog" class="pb-4">`;
            if (is_logged && view_type == 'own') {
                html += `
                    <label for="rackoot_enable_public">`+translations.rackoots.share.messages.enable+`</label>
                    <input id="rackoot_enable_public" type="checkbox" class="toggle toggle_colored me-4" value="true" data-toggle="toggle" ` + checked + ` data-rackoot-uuid="`+rackoot_data.dataset.uuid+`">
                `;
            } else {
                display_class = `d-block`;
            }
            html += `
                    <div id="rackoot_share_content" class="mt-4 `+display_class+`">
            `;

            if (is_logged && view_type == 'own') {
                html += `
                    <label for="rackoot_enable_suggestions">`+translations.rackoots.share.messages.suggestions.enable+`</label>
                    <input id="rackoot_enable_suggestions" type="checkbox" class="toggle toggle_colored me-4" value="true" data-toggle="toggle" ` + suggestionsChecked + ` data-rackoot-uuid="`+rackoot_data.dataset.uuid+`">
                `;
            }

            html += `
                <ul class="nav nav-tabs nav-fill mt-5 mb-0" id="tabs_bgs" role="tablist">
                            <li class="nav-item" role="presentation">
                                <a class="nav-link active" id="share-tab-url-tab" data-bs-toggle="tab" href="#share-tab-url" role="tab" aria-controls="share-tab-url" aria-selected="true">`+translations.rackoots.share.tabs.title_url+`</a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link" id="share-tab-social-tab" data-bs-toggle="tab" href="#share-tab-social" role="tab" aria-controls="share-tab-social" aria-selected="true">`+translations.rackoots.share.tabs.title_social+`</a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link" id="share-tab-qr-tab" data-bs-toggle="tab" href="#share-tab-qr" role="tab" aria-controls="share-tab-qr" aria-selected="true">`+translations.rackoots.share.tabs.title_qr+`</a>
                            </li>
                        </ul>

                        <div class="tab-content" id="bg-tabs-content">
                            <div class="tab-pane fade show active" id="share-tab-url" role="tabpanel" aria-labelledby="share-tab-url">
                                <p class="mt-3"><small>`+translations.rackoots.share.messages.body1+`</small></p>
                                <input class="form-control" type="text" readonly id="rackoot_share_url" value="` + rackoot_data.dataset.publicUrl + `"> <button class="btn btn-primary btn-sm mt-3" id="copy_rackoot_url" data-target="rackoot_share_url"><i class="fa fa-copy"></i> `+translations.rackoots.share.messages.buttonCopy+`</button>
                            </div>
                            <div class="tab-pane fade" id="share-tab-social" role="tabpanel" aria-labelledby="share-tab-social">
                                <div class="rackoot__share_buttons">` + share_buttons_template + `</div>
                            </div>
                            <div class="tab-pane fade" id="share-tab-qr" role="tabpanel" aria-labelledby="share-tab-qr">
                                <img src="`+rackoot_data.dataset.qrImage+`" id="share-qr-preview">
                                <div class="clearfix">
                                    <a href="`+rackoot_data.dataset.qrImageZip+`" class="btn btn-primary btn-lg">Download (high quality)</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;

            // Switch visibility
            document.body.addEventListener('click', function (e) {
                if (e.target && e.target.id == 'rackoot_enable_public') {
                    const checked = document.getElementById('rackoot_enable_public').checked;
                    // Indicator on navbar
                    const element = document.querySelector('#rackoots_nav .rackoot__item[data-rackoot-uuid="'+e.target.dataset.rackootUuid+'"]');
                    if (element !== null) {
                        const icon_element = element.querySelector('.rackoot__public_indicator');

                        const ico_public = icon_element.dataset.publicIcon;
                        const ico_private = icon_element.dataset.privateIcon;

                        icon_element.classList.remove(ico_public);
                        icon_element.classList.remove(ico_private);
                        if (checked) {
                            icon_element.classList.add(ico_public);
                        } else {
                            icon_element.classList.add(ico_private);
                        }
                    }

                    rackoot_data.dataset.public = checked.toString();

                    // Post
                    var data = new FormData();
                    data.append('csrf_name', csrf_name);
                    data.append('csrf_value', csrf_value);
                    data.append('rackoot_uuid', e.target.dataset.rackootUuid);
                    data.append('public', checked);

                    axios.post(GlobalRoutes.rackoots.switch_public_status, data)
                }
            });

            // Switch accept suggestions
            document.body.addEventListener('click', function (e) {
                if (e.target && e.target.id == 'rackoot_enable_suggestions') {
                    const checked = document.getElementById('rackoot_enable_suggestions').checked;
                    rackoot_data.dataset.acceptSuggestions = checked.toString();

                    // Post
                    var data = new FormData();
                    data.append('csrf_name', csrf_name);
                    data.append('csrf_value', csrf_value);
                    data.append('rackoot_uuid', e.target.dataset.rackootUuid);
                    data.append('accept_suggestions', checked);

                    axios.post(GlobalRoutes.rackoots.switch_accept_suggestions, data)
                }
            });

            

            // Copy public URL
            document.body.addEventListener('click', function (e) {
                if (e.target && e.target.id == 'copy_rackoot_url') {
                    copyToClipboard('rackoot_share_url');
                    new Toast(translations.urlCopied, Toast.TYPE_DONE, Toast.TIME_NORMAL);
                }
            });

            Swal.fire({
                title: translations.rackoots.share.messages.title.replace("{rackoot_name}", rackoot_name),
                html: html,
                showCloseButton: false,
                showCancelButton: true,
                showConfirmButton: false,
                cancelButtonText: translations.rackoots.share.messages.buttonCancel,
                focusCancel: true,
                buttonsStyling: false,
                width: '50%',
                customClass: {
                    cancelButton: 'btn btn-lg btn-light'
                },
                showClass: {
                    popup: 'animate__animated animated__fast animate__fadeInUp'
                },
                hideClass: {
                    popup: 'animate__animated animated__fast animate__fadeOutDown'
                }
            }).then((result) => {});
        }

    }
})();